import { OpeningHourTypeViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export type OpeningHourType = z.infer<typeof OpeningHourTypeViewSchema>;

export const StoreOpeningHourTypeSchema = z.object({
  name: z.string().min(1, { message: 'validation.required' }).max(255),
  public: z.boolean().nullable().optional(),
});

export type StoreOpeningHourTypePayload = z.infer<
  typeof StoreOpeningHourTypeSchema
>;
export const UpdateOpeningHourTypeSchema = StoreOpeningHourTypeSchema.partial();
export type UpdateOpeningHourTypePayload = z.infer<
  typeof UpdateOpeningHourTypeSchema
>;

export const openingHourTypeTranslations = _([
  'catalog.openingHourTypes.title',
  'catalog.openingHourTypes.add',
  'catalog.openingHourTypes.edit',
  'catalog.openingHourTypes.empty',
  'catalog.openingHourTypes.deleteConfirmHeader',
  'catalog.openingHourTypes.deleteConfirmMessage',
  'catalog.openingHourTypes.created',
  'catalog.openingHourTypes.updated',
  'catalog.openingHourTypes.deleted',
  'catalog.openingHourTypes.notFound',
  'catalog.openingHourTypes.loadError',
  'catalog.openingHourTypes.createError',
  'catalog.openingHourTypes.updateError',
  'catalog.openingHourTypes.deleteError',
  'catalog.openingHourTypes.dashboardDescription',
  'catalog.openingHourTypes.dashboardButton',
  'catalog.openingHourTypes.fields.name',
  'catalog.openingHourTypes.fields.public',
]);
